import { Routes } from '@angular/router'

import { AdminGuard, AuthGuard, UserGuard } from '~/core/guards'
import { FORECAST_LIST_PATH, NOT_FOUND_PATH, SIGN_IN_PATH } from '~const/index'

import {
  GUARD_SECTION_DATA_NAME,
  SEO_NOINDEX_ROUTE_DATA_NAME,
  SEO_PAGE_DATA_NAME,
} from './core/constants'
import { EGuardSectionName } from './core/models'
import { aggregationAnalysisQuarterDataResolver } from './pages/aggregation-analysis/aggregation-analysis.resolver'
import { companyForecastResolver } from './pages/company/company.resolver'
import { performanceQuarterListResolver } from './pages/performance/performance.resolver'
import { quarterlyDashboardQuarterDataResolver } from './pages/quarterly-dashboard/quarterly-dashboard.resolver'

export const APP_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/welcome').then(c => c.WelcomeComponent),
    canActivate: [UserGuard],
    data: {
      [SEO_PAGE_DATA_NAME]: {
        titleKey: 'seo.home.title',
        descriptionKey: 'seo.home.description',
        jsonLd: { type: 'WebSite', nameKey: 'seo.site.name' },
      },
    },
  },

  {
    path: SIGN_IN_PATH,
    loadComponent: () => import('./pages/sign-in').then(c => c.SignInComponent),
    canActivate: [UserGuard],
    data: {
      [SEO_NOINDEX_ROUTE_DATA_NAME]: true,
      [SEO_PAGE_DATA_NAME]: {
        titleKey: 'seo.signIn.title',
        descriptionKey: 'seo.signIn.description',
      },
    },
  },

  {
    path: FORECAST_LIST_PATH,
    loadChildren: () => import('./pages/dashboard/dashboard.routes').then(r => r.DASHBOARD_ROUTES),
    canActivate: [AuthGuard],
    data: { [GUARD_SECTION_DATA_NAME]: EGuardSectionName.FORECAST_TABLE },
  },

  { path: 'forecast', redirectTo: `/${FORECAST_LIST_PATH}` },

  {
    path: 'performance',
    loadChildren: () =>
      import('./pages/performance/performance.routes').then(r => r.PERFORMANCE_ROUTES),
    resolve: { resolve: performanceQuarterListResolver },
    data: {
      [SEO_PAGE_DATA_NAME]: {
        titleKey: 'seo.performance.title',
        descriptionKey: 'seo.performance.description',
      },
    },
  },

  {
    path: 'quarterly-dashboard',
    loadChildren: () =>
      import('./pages/quarterly-dashboard/quarterly-dashboard.routes').then(
        r => r.QUARTERLY_DASHBOARD_ROUTES
      ),
    resolve: { resolve: quarterlyDashboardQuarterDataResolver },
    canActivate: [AuthGuard],
    data: {
      [SEO_PAGE_DATA_NAME]: {
        titleKey: 'seo.quarterlyDashboard.title',
        descriptionKey: 'seo.quarterlyDashboard.description',
      },
    },
  },

  {
    path: 'aggregation-analysis',
    loadChildren: () =>
      import('./pages/aggregation-analysis/aggregation-analysis.routes').then(
        r => r.AGGREGATION_ANALYSIS_ROUTES
      ),
    resolve: { resolve: aggregationAnalysisQuarterDataResolver },
    canActivate: [AuthGuard],
    data: {
      [SEO_PAGE_DATA_NAME]: {
        titleKey: 'seo.aggregationAnalysis.title',
        descriptionKey: 'seo.aggregationAnalysis.description',
      },
    },
  },

  {
    path: 'user',
    loadChildren: () => import('./pages/user/user.routes').then(r => r.USER_ROUTES),
    canActivate: [AuthGuard],
  },

  {
    path: NOT_FOUND_PATH,
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(c => c.NotFoundComponent),
    data: {
      [SEO_NOINDEX_ROUTE_DATA_NAME]: true,
      [SEO_PAGE_DATA_NAME]: {
        titleKey: 'seo.notFound.title',
        descriptionKey: 'seo.notFound.description',
      },
    },
  },

  {
    path: 'admin',
    loadChildren: () => import('./pages/admin/admin.routes').then(r => r.ADMIN_ROUTES),
    canActivate: [AdminGuard],
  },

  {
    path: 'app-theme',
    loadComponent: () =>
      import('./pages/app-theme/app-theme.component').then(c => c.AppThemeComponent),
    data: {
      [SEO_NOINDEX_ROUTE_DATA_NAME]: true,
      [SEO_PAGE_DATA_NAME]: {
        titleKey: 'seo.appTheme.title',
        descriptionKey: 'seo.appTheme.description',
      },
    },
  },

  {
    path: ':ticker',
    loadChildren: () => import('./pages/company/company.routes').then(r => r.COMPANY_ROUTES),
    resolve: { resolve: companyForecastResolver },
    data: { [GUARD_SECTION_DATA_NAME]: EGuardSectionName.COMPANY_PAGE },
  },

  { path: '**', redirectTo: `/${NOT_FOUND_PATH}` },
]
